import { get } from 'lodash'
import axios from 'axios'

const baseURL = '/api/account/data/'

export default class AccountData {
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()

		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}
	setDefaultData (init = {}) {
		if (!init) return

		this.id = get(init, 'id') ? init.id : null
		this.data_type = get(init, 'data_type') ? init.data_type : ''
		this.data_value = get(init, 'data_value') ? init.data_value : ''

		this.errors = {}
	}
	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new AccountData(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	getSingle () {
		return axios.get(`${baseURL}${this.id}`)
			.then(({data}) => {
				this.setDefaultData(data.data)
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	get formData () {
		const formData = new FormData()

		formData.append('data_type', this.data_type)
		formData.append('data_value', this.data_value)

		return formData
	}
	create () {
		return axios.post(baseURL, this.formData)
			.then(res => res)
			.catch(err => {
				console.log(err)
				return err.response
			})
	}
	get urlSearchParams () {
		const params = new URLSearchParams()

		params.append('data_value', this.data_value)

		return params
	}
	update () {
		return axios.put(`${baseURL}${this.id}`, this.urlSearchParams)
			.then(res => res)
			.catch(err => {
				console.log(err)
				return err.response
			})
	}
	static dataTypeList = [
		{
			value: 'participants',
			name: 'Наставник для'
		},
		{
			value: 'specialization',
			name: 'Специализация'
		},
		{
			value: 'profile',
			name: 'Профиль'
		},
		{
			value: 'projectEvent',
			name: 'Мероприятия Кружкового Движения'
		}
	]
	createErrors (obj) {
		let newObj = {}
		for (let key in obj) {
			const newErrorStr = obj[key].reduce((accumulator, item) => {
				return accumulator + item
			}, '')

			newObj[key] = newErrorStr
		}
		this.errors = newObj
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/AccountData.class.js